import './App.css';
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import styled, { createGlobalStyle } from 'styled-components';
import QuestionForm from './components/QuestionForm';
import CardSelection from './components/CardSelection';
import Interpretation from './components/Interpretation';
import Header from './components/Header';
import { LanguageProvider } from './context/LanguageContext';
import sound from './audio/soundManager';

const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  body {
    /* Background and typography are managed in App.css using design tokens.
       We intentionally do NOT override the cosmic background here. */
  }
`;

const AppContainer = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  position: relative;
  z-index: 1;
`;

const MainContent = styled.main`
  flex: 1;
  width: 100%;
  max-width: var(--content-max);
  margin: 0 auto;
  padding: var(--space-6) var(--space-4) var(--space-7);

  @media (max-width: 768px) {
    padding: var(--space-5) var(--space-3) var(--space-6);
  }
`;

function App() {
  // 브라우저는 사용자 상호작용 전 자동 재생을 막으므로,
  // 첫 클릭/터치 시점에 (음소거가 아니라면) 배경음을 시작한다.
  useEffect(() => {
    const startOnFirstGesture = () => {
      if (!sound.isMuted()) {
        sound.startAmbient();
      }
    };
    window.addEventListener('pointerdown', startOnFirstGesture, { once: true });
    return () => window.removeEventListener('pointerdown', startOnFirstGesture);
  }, []);

  return (
    <LanguageProvider>
      <>
        <GlobalStyle />
        <AppContainer>
          <Router basename={process.env.PUBLIC_URL}>
            <Header />
            <MainContent>
              <Routes>
                <Route path="/" element={<QuestionForm />} />
                <Route path="/cards" element={<CardSelection />} />
                <Route path="/interpretation" element={<Interpretation />} />
              </Routes>
            </MainContent>
          </Router>
        </AppContainer>
      </>
    </LanguageProvider>
  );
}

export default App;
